import React from 'react';
import {Fragment} from 'react';


function Guides() {
    return (
        <Fragment>
            <div className="welcome-container">
                <h1> Guides </h1>
            </div>
            <div className="container">
                <h1>Beginner Guides</h1>
                
            </div>
        </Fragment>
    )
}
export default Guides;
